import {
  Badge,
  Card,
  CardBody,
  IconButton,
  Stat,
  StatGroup,
  StatLabel,
  StatNumber,
} from "@chakra-ui/react";
import { FundFamilyEventData } from "gen/model/fundFamilyEventData";
import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import React from "react";
import { useTranslation } from "react-i18next";
import { Restricted } from "shared/components/access/Restricted";
import {
  CardSection,
  CardSectionBody,
  CardSectionGroup,
} from "shared/components/card/CardSection";
import { EditIcon } from "shared/icons/EditIcon";
import { formatIsoDateToDisplay } from "shared/utils/DateUtils";

export interface CapitalCallReallocationStatCardProps {
  transactionDate: string;
  reallocationData: FundFamilyEventData;
  openEditDateModal?: () => void;
}

export const CapitalCallReallocationStatCard: React.FC<
  CapitalCallReallocationStatCardProps
> = ({ reallocationData, openEditDateModal, transactionDate }) => {
  const { t } = useTranslation([
    "capitalActivity",
    "capitalCall",
    "common",
    "notices",
    "enums",
  ]);

  return (
    <Card variant="stat" size="xs">
      <CardBody>
        <CardSectionGroup flexWrap="wrap">
          <CardSection flexGrow="1">
            <CardSectionBody alignItems="stretch">
              <StatGroup justifyContent="flex-start">
                <Stat>
                  <StatLabel>Effective Date</StatLabel>
                  <StatNumber>
                    <Badge>{formatIsoDateToDisplay(transactionDate)}</Badge>
                  </StatNumber>
                </Stat>
                <Stat flex="1" flexBasis="max-content" maxWidth="400px">
                  <StatLabel>{t("common:notesOptional")}</StatLabel>
                  <StatNumber whiteSpace="normal">
                    {reallocationData.notes || "-"}
                  </StatNumber>
                </Stat>
              </StatGroup>
              <Restricted permission={PermissionTypeEnum.write}>
                <IconButton
                  p="24px"
                  aria-label="edit"
                  size="sm"
                  variant="ghost"
                  borderRadius={0}
                  icon={<EditIcon w="20px" h="20px" color="gray.400" />}
                  onClick={openEditDateModal}
                />
              </Restricted>
            </CardSectionBody>
          </CardSection>
        </CardSectionGroup>
      </CardBody>
    </Card>
  );
};
